import React, { useState, useCallback, useRef, useEffect } from 'react'
import { Globe } from 'lucide-react'
import styles from './LanguageSwitcher.module.scss'

interface LanguageSwitcherProps {
  currentLocale: string
  locales: string[]
  onSwitch: (locale: string) => void
}

const LABELS: Record<string, string> = {
  en: 'EN',
  it: 'IT',
}

export const LanguageSwitcher: React.FC<LanguageSwitcherProps> = ({
  currentLocale,
  locales,
  onSwitch,
}) => {
  const [open, setOpen] = useState(false)
  const ref = useRef<HTMLDivElement>(null)

  const toggle = useCallback(() => setOpen((prev) => !prev), [])

  useEffect(() => {
    const handleClickOutside = (e: MouseEvent) => {
      if (ref.current && !ref.current.contains(e.target as Node)) {
        setOpen(false)
      }
    }
    document.addEventListener('mousedown', handleClickOutside)
    return () => document.removeEventListener('mousedown', handleClickOutside)
  }, [])

  return (
    <div className={styles.wrapper} ref={ref}>
      <button type="button" className={styles.trigger} onClick={toggle} aria-label="Switch language">
        <Globe size={16} />
        <span className={styles.label}>{LABELS[currentLocale] || currentLocale.toUpperCase()}</span>
      </button>
      {open && (
        <div className={styles.dropdown}>
          {locales.map((loc) => (
            <button
              key={loc}
              type="button"
              className={loc === currentLocale ? styles.active : styles.option}
              onClick={() => {
                onSwitch(loc)
                setOpen(false)
              }}
            >
              {LABELS[loc] || loc.toUpperCase()}
            </button>
          ))}
        </div>
      )}
    </div>
  )
}
